import { MutableRefObject, useEffect, useRef, useState } from "react";
import { GuestUser } from "@scrile/api-provider/dist/api/GuestUsersProvider";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { Subscription } from "apollo-client/util/Observable";
import useAuthUser from "hooks/useAuthUser";
import providers from "lib/providers";

function useController(
  token: string,
  containerRef: MutableRefObject<HTMLDivElement | null>,
  shouldScrollToBottom: MutableRefObject<boolean>,
  setHasUnreadMessage: (v: boolean) => void
) {
  const subscription = useRef<Subscription | null>(null);
  const { user } = useAuthUser();
  const [messages, setMessages] = useState<Message[]>([]);
  const [guestUser, setGuestUser] = useState<GuestUser | null>(null);

  useEffect(() => {
    if (token.length > 0) {
      (async () => {
        subscription.current = await providers.LivechatsProvider.subscribeMessageReceived(token, (data: Message) => {
          if (!containerRef.current) return;
          const bottomScrollTopPosition = containerRef.current.scrollHeight - containerRef.current.offsetHeight;
          if (data.senderId === user?.id || bottomScrollTopPosition - containerRef.current.scrollTop <= 100) {
            shouldScrollToBottom.current = true;
          }
          setMessages((prevState: Message[]) => [data, ...prevState]);
          setHasUnreadMessage(true);
        });
      })();
    }
    return () => {
      subscription.current && subscription.current.unsubscribe();
    };
  }, [token, user, shouldScrollToBottom, containerRef, setHasUnreadMessage]);

  return {
    messages,
    user,
    guestUser,
    setGuestUser,
  };
}

export default useController;
